import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';

interface Word {
    japaneseWord: string;
    correctDanishAnswer: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
    option5: string;
    option6: string;
}


interface WordsProps {
    onNextMode?: () => void;
    onScore?: (score: number) => void;
}

function WordsQuiz({ onNextMode, onScore }: WordsProps) {
    console.log('Quiz component rendered', onNextMode, onScore);
    const navigate = useNavigate();
    const [data, setData] = useState<Word[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [currentQuestion, setCurrentQuestion] = useState<number>(0);
    const [feedback, setFeedback] = useState<string | null>(null);
    const [correctCount, setCorrectCount] = useState<number>(0);
    const [wrongCount, setWrongCount] = useState<number>(0);

    // New state for button feedback and disabling
    const [clickedOption, setClickedOption] = useState<string | null>(null);
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [buttonsDisabled, setButtonsDisabled] = useState<boolean>(false);
    // For search input (if present)
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const username = process.env.REACT_APP_API_USERNAME;
                const password = process.env.REACT_APP_API_PASSWORD;
                const token = btoa(`${username}:${password}`);
                const response = await axios.get<Word[]>(`${process.env.REACT_APP_API_URL}/Word/35Words`,
                    {
                        headers: {
                            Authorization: `Basic ${token}`,
                        },
                    }
                );
                setData(response.data);
                setLoading(false);
            } catch (err) {
                setError('An error occurred while fetching data.');
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const items = data || [];
    const currentItem: Word = items[currentQuestion];

    const handleAnswer = (selectedOption: string, event: React.MouseEvent<HTMLButtonElement>) => {
        setButtonsDisabled(true);
        setClickedOption(selectedOption);

        if (selectedOption === currentItem.correctDanishAnswer) {
            setIsCorrect(true);
            setCorrectCount(correctCount + 1);
            if (onScore) onScore(1);
            setFeedback(null);
            setTimeout(() => {
                setClickedOption(null);
                setIsCorrect(null);
                setButtonsDisabled(false);
                if (currentQuestion < items.length - 1) {
                    setCurrentQuestion(currentQuestion + 1);
                } else {
                    alert('Quiz finished!');
                }
                if (onNextMode) onNextMode();
            }, 3500);
        } else {
            setIsCorrect(false);
            setWrongCount(wrongCount + 1);
            if (!onNextMode){
                setFeedback('Forkert svar. Prøv igen!');
            }else
            {
                setFeedback('Forkert svar!');
            }
            setTimeout(() => {
                setClickedOption(null);
                setIsCorrect(null);
                setButtonsDisabled(false);
                if (onNextMode) onNextMode();
            }, 1000);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (items.length === 0) {
        return <div>No questions available.</div>;
    }

    return (
        <div className="quiz-container">
            {/* Close button */}
            {!onNextMode && <button className="close-button" onClick={() => navigate('/')}>&times;</button>}

            <h2 className="quiz-title">Vælg det rette japanske udtryk</h2>
            <p className="quiz-description">Hvilket japansk ord passer til følgende dansk ord?</p>

            {/* Show counters */}
            {!onNextMode && <div style={{ marginBottom: '10px' }}>
                <span style={{ color: 'red' }}>Forkerte: {wrongCount}</span>
            </div>}

            {currentItem.japaneseWord ? (
                <h1>{currentItem.japaneseWord}</h1>
            ) : (
                <p className="quiz-description">{'Error'}</p>
            )}
            <div className="options">
                {/* Render all options dynamically */}
                {[1, 2, 3, 4, 5, 6].map(i => {
                    const option = (currentItem as any)[`option${i}`];
                    if (!option) return null;
                    let btnClass = "quiz-option";
                    console.log('Clicked option:', clickedOption, 'Current option:', option);
                    if (clickedOption === option) {
                        btnClass += isCorrect ? " quiz-option-correct" : " quiz-option-wrong";
                    }
                    return (
                        <button
                            key={option}
                            onClick={(event) => handleAnswer(option, event)}
                            className={btnClass}
                            disabled={buttonsDisabled}
                        >
                            {option}
                        </button>
                    );
                })}
            </div>
            {feedback && <p className="quiz-feedback" style={{ color: 'red' }}>{feedback}</p>}
            {!onNextMode && <p className="quiz-progress">Question {currentQuestion + 1} of {items.length}</p>}
        </div>
    );
}

export default WordsQuiz;
